import styled from "styled-components";

export const LogoutStyle = styled.span`
    cursor: pointer;
`;
